import type { GraphEditorState } from '../types';

type GraphData = GraphEditorState['graphData'];

export function cloneGraphData(data: GraphData): GraphData {
  return {
    materialNodes: Object.fromEntries(
      Object.entries(data.materialNodes).map(([id, spec]) => [
        id,
        {
          ...spec,
          constituents: spec.constituents ? spec.constituents.map((c) => ({ ...c })) : [],
          container: spec.container ? { ...spec.container } : spec.container,
          quantity: spec.quantity ? { ...spec.quantity, value: { ...spec.quantity.value } } : null,
        },
      ]),
    ),
    operationNodes: Object.fromEntries(
      Object.entries(data.operationNodes).map(([id, spec]) => [
        id,
        {
          ...spec,
          checkPoints: spec.checkPoints ? [...spec.checkPoints] : [],
          parameters: spec.parameters ? { ...spec.parameters } : {},
          approvers: spec.approvers?.users?.length ? { ...spec.approvers, users: [...spec.approvers.users] } : undefined,
          notifications: spec.notifications ? { ...spec.notifications, users: [...spec.notifications.users] } : undefined,
        },
      ]),
    ),
    flowEdges: Object.fromEntries(
      Object.entries(data.flowEdges).map(([id, spec]) => [id, { ...spec }]),
    ),
    groups: Object.fromEntries(
      Object.entries(data.groups).map(([id, spec]) => [
        id,
        {
          ...spec,
          stepIds: [...(spec.stepIds ?? [])],
          cycleRanges: (spec.cycleRanges ?? []).map((c) => ({ ...c })),
        },
      ]),
    ),
    graphComments: [...(data.graphComments ?? [])],
  };
}
